<template>
    <div class="policies-container pb-50px flex justify-center items-center w-100%">
        <AppHeader :title="t('copyright.title')" :show-back="true" />

        <div class="w-100% p-20px">
            <div class="flex flex-col mt-30px items-center justify-center">
                <p class="color-#FFFFFF text-center lh-14px text-12px">
                    {{ t('terms.intro', { appName: JSON.parse(parsed || '{}').AppName || 'RoleplayGF' }) }}
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">{{ t('terms.section1Title') }}</div>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section1_1') }}</p>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section1_2') }}</p>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section1_3') }}</p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">{{ t('terms.section2Title') }}</div>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section2_1', { appName: JSON.parse(parsed || '{}').AppName || 'RoleplayGF' }) }}</p>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section2_2') }}</p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">{{ t('terms.section3Title') }}</div>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section3_1') }}</p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">{{ t('terms.section4Title') }}</div>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section4_1') }}</p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">{{ t('terms.section5Title') }}</div>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section5_1') }}</p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">{{ t('terms.section6Title') }}</div>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section6_1', { appName: JSON.parse(parsed || '{}').AppName || 'RoleplayGF' }) }}</p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">{{ t('terms.section7Title') }}</div>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section7_1') }}</p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">{{ t('terms.section8Title') }}</div>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section8_1') }}</p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">{{ t('terms.section9Title') }}</div>
                <p class="color-#fff lh-14px text text-10px">{{ t('terms.section9_1') }}</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import theme from '@/styles/theme';
import { AppHeader } from '@/components';
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const parsed = localStorage.getItem('ai-chat-parsed')

// 政策和条款页面 - 不需要额外的数据
</script>

<style scoped lang="scss">
.policies-container {
    padding-bottom: 50px;
    background: v-bind('theme.colors.background');
    // min-height: 100vh;
}

.text {
    color: v-bind('theme.colors.textPrimary');
}

.info-item {
    padding: 10px;
    background-color: v-bind('theme.colors.backgroundQuaternary');
    margin-top: 10px;
}
</style>